var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _defs, _rect7, _circle, _circle2, _circle3, _circle4, _circle5, _rect8, _rect9, _rect10, _rect11, _circle6, _rect12, _rect13, _circle7, _rect14, _rect15, _circle8, _circle9, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreen11Player(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 780",
    width: 360,
    height: 780,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 780,
    fill: "#0c1218"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 19,
    width: 18,
    height: 8,
    rx: 2,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 19,
    width: 14,
    height: 8,
    rx: 2,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 18,
    width: 20,
    height: 10,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 12,
    width: 100,
    height: 24,
    rx: 12,
    fill: "#000",
    opacity: 1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "art",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ce1e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#2c7f86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a2531"
  })))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 80,
    width: 288,
    height: 288,
    rx: 26,
    fill: "url(#art)",
    opacity: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 224,
    r: 30,
    fill: "#05070a",
    opacity: 0.06
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 224,
    r: 52,
    fill: "#05070a",
    opacity: 0.06
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 224,
    r: 74,
    fill: "#05070a",
    opacity: 0.06
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 224,
    r: 96,
    fill: "#05070a",
    opacity: 0.06
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 224,
    r: 118,
    fill: "#05070a",
    opacity: 0.06
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 400,
    width: 190,
    height: 16,
    rx: 8,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 426,
    width: 120,
    height: 8,
    rx: 4,
    fill: "#4b5a68",
    opacity: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 468,
    width: 288,
    height: 6,
    rx: 3,
    fill: "#233142",
    opacity: 1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 468,
    width: 109.4,
    height: 6,
    rx: 3,
    fill: "#5ce1e6",
    opacity: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.4,
    cy: 471,
    r: 9,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 488,
    width: 30,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 488,
    width: 30,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 568,
    r: 38,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 554,
    width: 7,
    height: 28,
    rx: 2,
    fill: "#05070a",
    opacity: 1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 554,
    width: 7,
    height: 28,
    rx: 2,
    fill: "#05070a",
    opacity: 1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 568,
    r: 22,
    fill: "#1a2531",
    opacity: 1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 568,
    r: 22,
    fill: "#1a2531",
    opacity: 1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 672,
    width: 6,
    height: 8,
    rx: 3,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 651.6,
    width: 6,
    height: 28.4,
    rx: 3,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 646.7,
    width: 6,
    height: 33.3,
    rx: 3,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 660.9,
    width: 6,
    height: 19.1,
    rx: 3,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 660.5,
    width: 6,
    height: 19.5,
    rx: 3,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 646.6,
    width: 6,
    height: 33.4,
    rx: 3,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 651.9,
    width: 6,
    height: 28.1,
    rx: 3,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 671.6,
    width: 6,
    height: 8.4,
    rx: 3,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 651.4,
    width: 6,
    height: 28.6,
    rx: 3,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 646.8,
    width: 6,
    height: 33.2,
    rx: 3,
    fill: "#34424f",
    opacity: 1
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 661.3,
    width: 6,
    height: 18.7,
    rx: 3,
    fill: "#34424f",
    opacity: 1
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 660.1,
    width: 6,
    height: 19.9,
    rx: 3,
    fill: "#34424f",
    opacity: 1
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 646.5,
    width: 6,
    height: 33.5,
    rx: 3,
    fill: "#34424f",
    opacity: 1
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 652.2,
    width: 6,
    height: 27.8,
    rx: 3,
    fill: "#34424f",
    opacity: 1
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 671.1,
    width: 6,
    height: 8.9,
    rx: 3,
    fill: "#34424f",
    opacity: 1
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 651.1,
    width: 6,
    height: 28.9,
    rx: 3,
    fill: "#34424f",
    opacity: 1
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 646.9,
    width: 6,
    height: 33.1,
    rx: 3,
    fill: "#34424f",
    opacity: 1
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 661.7,
    width: 6,
    height: 18.3,
    rx: 3,
    fill: "#34424f",
    opacity: 1
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 659.7,
    width: 6,
    height: 20.3,
    rx: 3,
    fill: "#34424f",
    opacity: 1
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 646.4,
    width: 6,
    height: 33.6,
    rx: 3,
    fill: "#34424f",
    opacity: 1
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 652.5,
    width: 6,
    height: 27.5,
    rx: 3,
    fill: "#34424f",
    opacity: 1
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 670.7,
    width: 6,
    height: 9.3,
    rx: 3,
    fill: "#34424f",
    opacity: 1
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 650.8,
    width: 6,
    height: 29.2,
    rx: 3,
    fill: "#34424f",
    opacity: 1
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 647,
    width: 6,
    height: 33,
    rx: 3,
    fill: "#34424f",
    opacity: 1
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 766,
    width: 120,
    height: 5,
    rx: 2.5,
    fill: "#dfe6e8",
    opacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen11Player);
export default __webpack_public_path__ + "static/media/screen-11-player.52911100edc2f85f366d3d25e4e514ac.svg";
export { ForwardRef as ReactComponent };